import React from 'react'
import clsx from 'clsx'
import { useHistory } from 'react-router'

import { Routes } from '../../../../../Routes'
import useStyles from './styles'

const ViewMore = ({ className }) => {
  const history = useHistory()

  const classes = useStyles()

  const handleMoreClicked = React.useCallback(() => {
    history.push(Routes.NOTIFICATIONS)
  }, [history])

  return (
    <div className={clsx(classes.root, className)}>
      <div onClick={handleMoreClicked}>View all notifications</div>
    </div>
  )
}

export default ViewMore
